import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { eOrderType, ePartyType, Order, OrderManagerService, UboTreeNode, UboTreeNodesService, ValidationProblem, ValidationService } from 'reg-hub-common';
import { SteppedComponent } from 'projects/reg-hub-client/src/interfaces/stepped-component';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-business-report-review',
    templateUrl: './business-report-review.component.html',
    styleUrls: ['./business-report-review.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BusinessReportReviewComponent extends SteppedComponent {
  private readonly transloco = inject(TranslocoService);
  protected linkToHubReportNodeTexts: string[] = [];

  constructor(
    private uboTreeService: UboTreeNodesService,
    orderManager: OrderManagerService,
    validationService: ValidationService) { super(orderManager, validationService); }

  protected override init(order: Order): void {
    super.init(order);
    this.validate(this.order);

    if (order.businessReportCriteria?.number) {
      this.uboTreeService.getUboTrees({
        businessNumber: order.businessReportCriteria.number, 
        businessCountry: order.country,
        businessJurisdiction: order.jurisdiction,
        partyTypes: [ePartyType.businessShareholder],
        includesNoOrderOfTypes: [eOrderType.businessReport]
      }, true).subscribe(nodes => {
        this.linkToHubReportNodeTexts = [...new Map(nodes.map(n => [n["hubReportID"], n])).values()].map(node => this.transloco.translate('orders.criteriaMatchesShareholder', { reference: node.hubReportReference }))
      });
    } else {
      this.uboTreeService.linkToHubReportNodes.next([]);
    }
  }
  
  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return (errors?.length ?? 0) === 0 ? StepValidationState.ValidationSuccess : StepValidationState.ValidationError;
  }
}